import { Fragment, useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// CUSTOM DEFINED HOOK
import useAuth from 'hooks/useAuth';
import useLocation from 'hooks/useLocation';
import toast from 'react-hot-toast';

export default function GuestGuard({ children }) {
  const { state } = useLocation();
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const isToastShown = useRef(true);

  useEffect(() => {
    if (
      (pathname === '/set-password' ||
        pathname === '/company-registration' ||
        pathname === '/email-verification') &&
      isToastShown.current &&
      isAuthenticated
    ) {
      setTimeout(() => {
        toast.error('Please Sign out and open link again');
      }, 0);
      isToastShown.current = false;
    }
  }, [pathname, isAuthenticated, isToastShown]);

  if (isAuthenticated) {
    if (state?.from) return <Navigate to={state.from} />;
    return <Navigate to="/dashboard/trips" />;
  }

  return <Fragment>{children || <Outlet />}</Fragment>;
}
